<app-news-offline-results
  *ngIf="mappedOfflineNews"
  [news]="mappedOfflineNews"
  [customTable]="true"
></app-news-offline-results>
<div class="full-results-table">
  <a [href]="news.cup.customNews"> >> <span translate translation="fullResultsTable"></span> << </a>
</div>
